import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const MetaPixelTracker = () => {
    const location = useLocation();
    useEffect(() => {
        if (typeof fbq !== "undefined") {
            fbq("track", "PageView");
        }
    }, [location.pathname]);
    return null;
};

export default MetaPixelTracker;
